<template>
    <s-modal
        :open="open"
        :close="true"
        title="Configurer le timer pour cette équipe"
        @close="$emit('close')"
    >
        <div v-if="equipe">
            <div v-if="equipe.timer"> 
                <s-button  label="Mettre en pause le timer" v-if="equipe.timer.state=='play'" theme="is-primary"
                    @onclick="setTimer('pause')"/>
                <s-button  label="Faire partir le timer" v-if="equipe.timer.state=='pause'" theme="is-success"
                    @onclick="setTimer('play')"/>
                    <div style="margin-top: 10px" v-if="equipe.timer.state=='pause'">
                        <input class="input is-rounded is-primary is-small" v-model="delayPartie" style="width:150px"/> mn &nbsp;
                        <s-button icon="refresh" label="Reinitialiser" theme="is-primary" @onclick="saveDelay"/> 
                    </div>
                <br/>
            </div>
            <div v-else>
                <s-button label="Activer le timer" @onclick="activeTimer" theme="is-success"/>
            </div>
        </div>
       
    </s-modal>
</template>
<script>
    import firebase from 'firebase'
    import firebase_api from '@/firebase/firebase_api'
    export default {
        props: ["equipe", "open", "indexPartie", "firestore", "tournoi"],
        data() {
            return {
                delayPartie: null
            }
        },
        mounted() {
            if (typeof(this.tournoi.timer)!="undefined")
                this.delayPartie = this.tournoi.timer.delay;
        },
        methods: {
            activeTimer() {
                const functions = firebase.app().functions('europe-west1');
                    functions.httpsCallable("stamp")().then(res=>{
                        console.log(this.equipe.id);
                        this.firestore.equipes.doc(this.equipe.id).update({
                                    timer: {
                                        state: "pause",
                                        ts: res.data.timeStamp,
                                        delay : this.tournoi.timer.delay
                                    }
                                })
                    })
                this.$emit('close');
            },
            saveDelay() {
                this.firestore.equipes.doc(this.equipe.id).update({
                    "timer.state": "pause",
                    "timer.delay":  parseInt(this.delayPartie)
                }).then(up=>{
                     this.$emit('close');
                })
                this.equipe.timer.state = "pause";
               
            },
            setTimer(state) {
              
                const functions = firebase.app().functions('europe-west1');
                    functions.httpsCallable("stamp")().then(res=>{
                    if (state == "play") {
                            this.firestore.equipes.doc(this.equipe.id).update({
                                "timer.state": state,
                                "timer.ts":res.data.timeStamp
                            })
                            this.equipe.timer.state = "play";
                              this.$emit('close');
                    }
                    else {
                       this.$emit("stopTimer", this.equipe.id)
                       
                    }
                })
            }
        }
    }
</script>